import React, { useEffect, useState, useCallback } from 'react';
import styles from './style.module.css';
import HeaderInternal from '../../../Components/HeaderInternal';
import { getBotWithNumber, getCinnDiTemplates, createCommunicationRules, getCommunicationRules, deleteCommunicationRules } from '../../../services/kollectaApi';
import Select from '../../../Components/Select';
import StatusSelector from '../../../Components/StatusSelector';
import DaySelector from '../../../Components/DaySelector';
import CustomTimePicker from '../../../Components/TimePicker';
import Modal from '../../../Components/Modal';
import successIcon from '../../../assets/images/success.png';
import errorIcon from '../../../assets/images/error.svg';
import LixeiraIcon from '../../../Components/DropdownMenu/lixeira.svg';
import AlertDeleteIcon from '../../../assets/images/alert-delete.svg';

const BOLETO_BULLLA_MARKER = 'BOLETO_BULLLA';
const BULLLA_COMPANY_IDS = ['2853b377-d0e3-4882-b8cb-74f71fb3f661'];
const BULLLA_BOLETO_TEMPLATE_NAME = 'bullla_v06';

function formatPhoneNumber(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
  }
  if (cleaned.length === 12) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
  }
  return phone;
}

const CommunicationDispatcher = () => {
  const [botData, setBotData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [existingRules, setExistingRules] = useState([]);
  const [existingRulesLoading, setExistingRulesLoading] = useState(false);
  const [deletingRuleId, setDeletingRuleId] = useState(null);


  
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [ruleIndexToDelete, setRuleIndexToDelete] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  // Controle de scroll quando modais estão abertos
  useEffect(() => {
    if (showSuccessModal || showErrorModal || showDeleteSuccessModal || showDeleteConfirmModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [showSuccessModal, showErrorModal, showDeleteSuccessModal, showDeleteConfirmModal]);

  const templateOptions = templates.map(template => ({


    value: template.id,
    label: template.nome
  }));

  const delayOptions = [
    { value: '-7-7', label: 'D-7' },
    { value: '-3-3', label: 'D-3' },
    { value: '-1-1', label: 'D-1' },
    { value: '0-0', label: 'D+0' },
    { value: '1-30', label: 'Atraso entre 1 a 30 dias' },
    { value: '31-9999', label: 'Atraso acima de 30 dias' },
    { value: '31-60', label: 'Atraso entre 31 a 60 dias' },
    { value: '61-9999', label: 'Atraso acima de 60 dias' },
    { value: '61-90', label: 'Atraso entre 61 a 90 dias' },
    { value: '91-9999', label: 'Atraso acima de 90 dias' },
    { value: '91-120', label: 'Atraso entre 91 a 120 dias' },
    { value: '121-9999', label: 'Atraso acima de 120 dias' },
    { value: '121-150', label: 'Atraso entre 121 a 150 dias' },
    { value: '151-9999', label: 'Atraso acima de 150 dias' },
    { value: '151-180', label: 'Atraso entre 151 a 180 dias' },
    { value: '181-1800', label: 'Atraso acima de 180 dias' },
  ];


  const frequencyOptions = [
    { value: 'semanal', label: 'Semanal' },
    { value: 'quinzenal', label: 'Quinzenal' },
    { value: 'mensal', label: 'Mensal' },
    { value: 'anual', label: 'Anual' },
  ];

  const fetchTemplates = async (botNumber) => {
    try {
      setTemplatesLoading(true);
      const response = await getCinnDiTemplates(botNumber);
      console.log('response', response?.data);
      if (response.data.success && response.data?.data?.lista) {
        console.log('templates', response.data?.data?.lista);

        const approvedTemplates = response.data?.data?.lista.filter(template => template.status === 'APPROVED') || [];
        console.log('approved templates', approvedTemplates);
        setTemplates(approvedTemplates);
      }
    } catch (err) {
      console.error('Erro ao buscar templates:', err);
      setErrorMessage('Erro ao buscar templates.');
      setShowErrorModal(true);
    } finally {
      setTemplatesLoading(false);
    }
  };

  const fetchExistingRules = async (botNumber) => {
    try {
      setExistingRulesLoading(true);
      const response = await getCommunicationRules();
      console.log('Regras existentes:', response?.data);

      if (response.data && Array.isArray(response.data)) {
        // Filtrar regras pelo número do bot atual
        const filteredRules = response.data.filter(rule => rule.companyWhatsappNumber === botNumber);
        setExistingRules(filteredRules);
      }
    } catch (err) {
      console.error('Erro ao buscar regras existentes:', err);
      setErrorMessage('Erro ao buscar regras existentes.');
      setShowErrorModal(true);
    } finally {
      setExistingRulesLoading(false);
    }
  };

  const convertApiRuleToLocalFormat = useCallback((apiRule) => {
    const selectedDays = [];
    if (apiRule.monday) selectedDays.push('monday');
    if (apiRule.tuesday) selectedDays.push('tuesday');
    if (apiRule.wednesday) selectedDays.push('wednesday');
    if (apiRule.thursday) selectedDays.push('thursday');
    if (apiRule.friday) selectedDays.push('friday');
    if (apiRule.saturday) selectedDays.push('saturday');
    if (apiRule.sunday) selectedDays.push('sunday');

    const timeString = apiRule.horario || '00:00';
    const [hours, minutes] = timeString.split(':');
    const selectedTime = new Date();
    selectedTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);

    const templateVariables = {};
    if (apiRule.templateVariable1) templateVariables['1'] = apiRule.templateVariable1;
    if (apiRule.templateVariable2) templateVariables['2'] = apiRule.templateVariable2;
    if (apiRule.templateVariable3) templateVariables['3'] = apiRule.templateVariable3;
    if (apiRule.templateVariable4) templateVariables['4'] = apiRule.templateVariable4;
    if (apiRule.templateVariable5) templateVariables['5'] = apiRule.templateVariable5;

    const matchingTemplate = templates.find(t => t.nome === apiRule.whatsappTemplate);

    return {
      id: apiRule.id,
      isActive: true, // Flag para indicar que é uma regra ativa
      selectedTemplate: matchingTemplate ? matchingTemplate.id : '',
      selectedStatuses: apiRule.statusToSend || [],
      selectedDelay: apiRule.atrasoMedio || '',
      selectedDays: selectedDays,
      selectedFrequency: apiRule.frequenciaDisparos || '',
      selectedTime: selectedTime,
      templateVariables: templateVariables,
      createdAt: apiRule.createdAt,
      creator: apiRule.Creator,
      originalTemplateName: apiRule.whatsappTemplate // Manter o nome original do template
    };
  }, [templates]);

  useEffect(() => {
    const fetchBotData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const companyId = user?.companyId;

        if (companyId) {
          const response = await getBotWithNumber(companyId);
          const bot = response.data[0];
          setBotData(bot);

          if (bot?.botNumber) {
            await Promise.all([
              fetchTemplates(bot.botNumber),
              fetchExistingRules(bot.botNumber)
            ]);
          }
        }
      } catch (err) {
        setErrorMessage('Erro ao buscar dados do disparador.');
        setShowErrorModal(true);
      } finally {
        setLoading(false);
      }
    };
    fetchBotData();
  }, []);


  const extractTemplateVariables = (template) => {
    if (!template || !template.componentes) return [];

    const variables = [];

    template.componentes.forEach(componente => {
      if (componente.text) {
        const matches = componente.text.match(/\{\{(\d+)\}\}/g);
        if (matches) {
          matches.forEach(match => {
            const number = match.match(/\d+/)[0];
            if ((number === "1" || number === "2" || number === "3" || number === "4" || number === "5" || number === "6" || number === "7") && !variables.includes(number)) {
              variables.push(number);
            }
          });
        }
      }
    });

    return variables.sort((a, b) => parseInt(a) - parseInt(b));
  };

  const getTemplatePreview = (template) => {
    if (!template || !template.componentes) return [];

    const hasOrderDetailsButton = template.componentes.some(componente =>
      componente.type === "BUTTONS" &&
      componente.buttons &&
      componente.buttons.some(button => button.type === "ORDER_DETAILS")
    );

    console.log('%cHas pix', 'color: red');
    console.log(hasOrderDetailsButton);

    return template.componentes.map(componente => {
      if (componente.text) {
        let previewText = componente.text;

        if (previewText.includes('{{1}}')) {
          previewText = previewText.replace(/\{\{1\}\}/g, 'NOME');
        }

        // ORDER DETAILS template
        if (hasOrderDetailsButton) {
          if (previewText.includes('{{2}}')) {
            previewText = previewText.replace(/\{\{2\}\}/g, 'EMPRESA LTDA');
          }
          if (previewText.includes('{{3}}')) {
            previewText = previewText.replace(/\{\{3\}\}/g, '03/10/2025');
          }
        } else {
          if (previewText.includes('{{2}}')) {
            previewText = previewText.replace(/\{\{2\}\}/g, 'R$ 150,00');
          }
          if (previewText.includes('{{3}}')) {
            previewText = previewText.replace(/\{\{3\}\}/g, 'EMPRESA LTDA');
          }
        }

        if (previewText.includes('{{4}}')) {
          previewText = previewText.replace(/\{\{4\}\}/g, '31/12/2024');
        }
        if (previewText.includes('{{5}}')) {
          previewText = previewText.replace(/\{\{5\}\}/g, 'PIX123456789');
        }
        if (previewText.includes('{{6}}')) {
          previewText = previewText.replace(/\{\{6\}\}/g, '12345');
        }
        if (previewText.includes('{{7}}')) {
          previewText = previewText.replace(/\{\{7\}\}/g, '12.345.678/0001-90');
        }

        // Se tem ORDER_DETAILS e não tem as variáveis no texto, adiciona no final para preview
        if (hasOrderDetailsButton && !previewText.includes('{{6}}') && !previewText.includes('{{7}}')) {
          previewText += '\n\n[Variáveis automáticas para ORDER_DETAILS:]\n{{6}} - ID da Dívida\n{{7}} - CNPJ';
        }
        return { ...componente, text: previewText };
      }
      return componente;
    });
  };

  const [rules, setRules] = useState([
    {
      selectedTemplate: '',
      selectedStatuses: [],
      selectedDelay: '',
      selectedDays: [],
      selectedFrequency: '',
      selectedTime: new Date(),
      templateVariables: {}, // Added for template variables
    },
  ]);

  // Carregar regras existentes quando elas forem carregadas
  useEffect(() => {
    if (existingRules.length > 0 && templates.length > 0) {
      const convertedRules = existingRules.map(convertApiRuleToLocalFormat);
      setRules(convertedRules);
    }
  }, [existingRules, templates, convertApiRuleToLocalFormat]);

  const handleRuleChange = (index, field, value) => {
    setRules(prevRules => {
      const newRules = [...prevRules];
      newRules[index][field] = value;
      return newRules;
    });
  };

  const handleAddRule = () => {
    setRules(prevRules => ([
      ...prevRules,
      {
        selectedTemplate: '',
        selectedStatuses: [],
        selectedDelay: '',
        selectedDays: [],
        selectedFrequency: '',
        selectedTime: new Date(),
        templateVariables: {},
      },
    ]));
  };

  const handleRemoveRule = (index) => {
    const ruleToRemove = rules[index];
    if (ruleToRemove.isActive && ruleToRemove.id) {
      setRuleIndexToDelete(index);
      setShowDeleteConfirmModal(true);
      setTimeout(() => { scrollToModal(); }, 100);
    } else {
      setRules(prevRules => prevRules.filter((_, i) => i !== index));
    }
  };

  const confirmDeleteRule = async () => {
    const index = ruleIndexToDelete;
    const ruleToRemove = rules[index];
    setShowDeleteConfirmModal(false);
    setRuleIndexToDelete(null);
    try {
      setDeletingRuleId(ruleToRemove.id);
      await deleteCommunicationRules(ruleToRemove.id);

      setRules(prevRules => prevRules.filter((_, i) => i !== index));

      if (botData?.botNumber) {
        await fetchExistingRules(botData.botNumber);
      }
      setShowDeleteSuccessModal(true);
    
    } catch (error) {
      setErrorMessage('Erro ao deletar regra. Tente novamente.');
      setShowErrorModal(true);
      scrollToModal();
    } finally {
      setDeletingRuleId(null);
    }
  };

  const scrollToModal = () => {
    setTimeout(() => {
      const modal = document.querySelector('[data-modal]');
      if (modal) {
        modal.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const handleSaveAllRules = async () => {
    try {
      if (botData?.qualidade && botData.qualidade !== 'GREEN') {
        setErrorMessage('Não é possível criar regras de disparo. O número do WhatsApp possui qualidade baixa e precisa permanecer inativo por um período de 7 dias devido à alta detecção de spam.');
        setShowErrorModal(true);
        scrollToModal();
        return;
      }

      const user = JSON.parse(localStorage.getItem('user'));
      const companyId = user?.companyId;
      if (!companyId) {
        setErrorMessage('Erro: ID da empresa não encontrado.');
        setShowErrorModal(true);
        scrollToModal();
        return;
      }

      const newRules = rules.filter(rule => !rule.isActive);

      for (let i = 0; i < newRules.length; i++) {
        const rule = newRules[i];
        if (!rule.selectedTemplate) {
          setErrorMessage(`Por favor, selecione um template na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }

        const selectedTemplateDetails = templates.find(t => t.id === rule.selectedTemplate);
        if (!selectedTemplateDetails) {
          setErrorMessage(`Template não encontrado na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }
        if (rule.selectedStatuses.length === 0) {
          setErrorMessage(`Por favor, selecione pelo menos um status na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }
        if (!rule.selectedDelay) {
          setErrorMessage(`Por favor, selecione um atraso médio na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }
        if (!rule.selectedDays || rule.selectedDays.length === 0) {
          setErrorMessage(`Por favor, selecione pelo menos um dia da semana na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }
        if (!rule.selectedFrequency) {
          setErrorMessage(`Por favor, selecione uma frequência na regra ${i + 1}.`);
          setShowErrorModal(true);
          scrollToModal();
          return;
        }

        const timeString = rule.selectedTime.toTimeString().slice(0, 5);

        // Verifica se o template tem um botão ORDER_DETAILS
        const hasOrderDetailsButton = selectedTemplateDetails.componentes.some(componente =>
          componente.type === "BUTTONS" &&
          componente.buttons &&
          componente.buttons.some(button => button.type === "ORDER_DETAILS")
        );

        console.log('%cHas pix', 'color: red');
        console.log(hasOrderDetailsButton);

        const isBoletoBulllaReminder =
          !hasOrderDetailsButton &&
          rule.selectedStatuses.includes('pending') &&
          (selectedTemplateDetails.nome || '').trim() === BULLLA_BOLETO_TEMPLATE_NAME &&
          BULLLA_COMPANY_IDS.includes(user?.companyId);

        const ruleData = {
          communicationType: "whatsapp",
          integrationType: "internal",
          companyWhatsappNumber: botData?.botNumber,
          frequenciaDisparos: rule.selectedFrequency,
          whatsappTemplate: selectedTemplateDetails?.nome || rule.selectedTemplate,
          // Para ORDER_DETAILS, sempre salva todas as variáveis (1-7)
          templateVariable1: hasOrderDetailsButton
            ? "name"
            : (isBoletoBulllaReminder
              ? BOLETO_BULLLA_MARKER
              : (extractTemplateVariables(selectedTemplateDetails).includes("1") ? "name" : "")),
          templateVariable2: hasOrderDetailsButton ? "company" : (extractTemplateVariables(selectedTemplateDetails).includes("2") ? "amount" : ""),
          templateVariable3: hasOrderDetailsButton ? "amount" : (extractTemplateVariables(selectedTemplateDetails).includes("3") ? "company" : ""),
          templateVariable4: hasOrderDetailsButton ? "pix_expiration_date" : (extractTemplateVariables(selectedTemplateDetails).includes("4") ? "pix_expiration_date" : ""),
          templateVariable5: hasOrderDetailsButton ? "pix_data" : (extractTemplateVariables(selectedTemplateDetails).includes("5") ? "pix_data" : ""),
          templateVariable6: hasOrderDetailsButton ? "pastDueId" : "",
          templateVariable7: hasOrderDetailsButton ? "cnpj" : "",
          monday: rule.selectedDays.includes('monday') ? timeString : null,
          tuesday: rule.selectedDays.includes('tuesday') ? timeString : null,
          wednesday: rule.selectedDays.includes('wednesday') ? timeString : null,
          thursday: rule.selectedDays.includes('thursday') ? timeString : null,
          friday: rule.selectedDays.includes('friday') ? timeString : null,
          saturday: rule.selectedDays.includes('saturday') ? timeString : null,
          sunday: rule.selectedDays.includes('sunday') ? timeString : null,
          statusToSend: rule.selectedStatuses,
          atrasoMedio: rule.selectedDelay,
          horario: timeString,
        };
        console.log('Enviando dados para API:', ruleData);
        const response = await createCommunicationRules(ruleData);
        console.log('Resposta da API:', response);
        if (response.status !== 201) {
          setErrorMessage('Erro ao criar regra: ' + (response.data?.message || 'Erro desconhecido'));
          setShowErrorModal(true);
          scrollToModal();
          return;
        }
      }
      setShowSuccessModal(true);
      

      if (botData?.botNumber) {
        await fetchExistingRules(botData.botNumber);
      }
    } catch (error) {
      console.error('Erro ao salvar regras:', error);
      setErrorMessage('Erro ao salvar regras. Verifique o console para mais detalhes.');
      setShowErrorModal(true);
      scrollToModal();
    }
  };

  return (
    <div className={styles.wrapper}>
      <HeaderInternal title="Regras do disparador" bold={true} />
      <div className={styles.content}>
        <div className={styles['content-area']}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{ fontSize: 16, color: '#666' }}>Carregando...</div>
            </div>
          ) : !botData || !botData.botNumber ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{
                background: '#f5f5f5',
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                padding: '32px',
                maxWidth: 500,
                margin: '0 auto'
              }}>
                <svg width="64" height="64" fill="#999" style={{ margin: '0 auto 16px', display: 'block' }} viewBox="0 0 24 24">
                  <path d="M12 22c5.421 0 10-4.579 10-10s-4.579-10-10-10-10 4.579-10 10 4.579 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm-1 5h2v6h-2v-6zm0 8h2v2h-2v-2z" />
                </svg>
                <h3 style={{ margin: '0 0 16px', color: '#333', fontSize: 20, fontWeight: 600 }}>
                  Nenhum número cadastrado
                </h3>
                <p style={{ margin: 0, color: '#666', fontSize: 16, lineHeight: 1.5 }}>
                  Para configurar as regras do disparador, é necessário ter um número de WhatsApp cadastrado no sistema.
                </p>
              </div>
            </div>
          ) : (
            <>
              <h2>Status de qualidade do número</h2>
              <div style={{ marginBottom: 32, marginLeft: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 8 }}>
                  <span style={{ fontSize: 18, fontWeight: 500 }}>
                    {formatPhoneNumber(botData?.botNumber)}
                  </span>
                  {botData?.qualidade && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div
                        style={{
                          width: 12,
                          height: 12,
                          borderRadius: '50%',
                          backgroundColor: botData.qualidade === 'GREEN' ? '#52c41a' : '#faad14'
                        }}
                      />
                      <span style={{ fontSize: 14, color: '#666' }}>
                        {botData.qualidade === 'GREEN' ? 'Alta qualidade' : 'Baixa qualidade'}
                      </span>
                    </div>
                  )}
                </div>
                {botData?.qualidade && botData.qualidade !== 'GREEN' && (
                  <div style={{ marginTop: 8, background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 4, padding: 8, color: '#ad8b00', fontSize: 13, maxWidth: 600 }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <svg width="16" height="16" fill="#f7c948" style={{ marginRight: 4 }} viewBox="0 0 24 24"><path d="M12 22c5.421 0 10-4.579 10-10s-4.579-10-10-10-10 4.579-10 10 4.579 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm-1 5h2v6h-2v-6zm0 8h2v2h-2v-2z" /></svg>
                      Devido a alta detecção de spam, o número precisa permanecer inativo, sem realizar disparos, por um período de 7 dias.
                    </span>
                  </div>
                )}
              </div>

              <div className={styles.configSection}>
                <h3>Regras de disparo</h3>
                <p>Configure abaixo as regras de negócio do seu disparo.</p>

                {existingRulesLoading && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    Carregando regras existentes...
                  </div>
                )}

                <div className={styles.buttonContainer} style={{ justifyContent: 'flex-end', marginBottom: 16 }}>
                  <button
                    className={styles.saveButton}
                    onClick={handleSaveAllRules}
                    disabled={botData?.qualidade && botData.qualidade !== 'GREEN'}
                    style={{
                      opacity: botData?.qualidade && botData.qualidade !== 'GREEN' ? 0.5 : 1,
                      cursor: botData?.qualidade && botData.qualidade !== 'GREEN' ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Salvar regras
                  </button>
                </div>
                {rules.map((rule, idx) => (
                  <div key={idx} className={styles.formGrid} style={{
                    border: '1px solid #1B2752',
                    borderRadius: 8,
                    padding: 16,
                    paddingTop: 48,
                    marginBottom: 24,
                    position: 'relative',
                    background: rule.isActive ? '#f8f9fa' : '#fff'
                  }}>
                    {rule.isActive && (
                      <div style={{
                        gridColumn: '1 / -1',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: '#f6ffed',
                        border: '2px solid #52c41a',
                        color: '#389e0d',
                        padding: '2px 16px',
                        borderRadius: 20,
                        fontSize: 14,
                        fontWeight: 700,
                        maxWidth: 75,
                        boxShadow: '0 1px 2px rgba(82,196,26,0.04)'
                      }}>
                        Regra ativa
                      </div>
                    )}

                    <button
                      onClick={() => handleRemoveRule(idx)}
                      disabled={deletingRuleId === rule.id}
                      style={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        background: 'transparent',
                        border: 'none',
                        fontWeight: 'bold',
                        fontSize: 18,
                        cursor: deletingRuleId === rule.id ? 'not-allowed' : 'pointer',
                        opacity: deletingRuleId === rule.id ? 0.5 : 1,
                        padding: 8,
                        zIndex: 10
                      }}
                      title={deletingRuleId === rule.id ? "Removendo..." : "Remover regra"}
                    >
                      <img src={LixeiraIcon} alt="Deletar" style={{ width: 24, height: 24, display: 'block', filter: 'brightness(0) saturate(100%) invert(15%) sepia(15%) saturate(2000%) hue-rotate(200deg) brightness(0.3) contrast(1.2)' }} />
                    </button>

                    {rule.isActive && rule.createdAt && (
                      <div style={{
                        gridColumn: '1 / -1',
                        marginBottom: 16,
                        padding: 8,
                        background: '#e6f7ff',
                        borderRadius: 4,
                        fontSize: 12,
                        border: '1px solid #91d5ff',
                        color: '#1890ff'
                      }}>
                        <strong>Criada em:</strong> {new Date(rule.createdAt).toLocaleDateString('pt-BR')}
                        {rule.creator && (
                          <span style={{ marginLeft: 16 }}>
                            <strong>por:</strong> {rule.creator.name}
                          </span>
                        )}
                      </div>
                    )}

                    {((rule.selectedTemplate && templates.find(t => t.id === rule.selectedTemplate)) || (rule.isActive && rule.originalTemplateName)) && (
                      <div style={{
                        gridColumn: '1 / -1',
                        marginBottom: 16,
                        padding: 12,
                        background: '#f5f5f5',
                        borderRadius: 4,
                        fontSize: 13,
                        border: '1px solid #e0e0e0'
                      }}>
                        <div style={{ marginBottom: 8 }}>
                          <strong>Template:</strong> {rule.isActive ? rule.originalTemplateName : (templates.find(t => t.id === rule.selectedTemplate)?.nome || rule.selectedTemplate)}
                        </div>
                        {!rule.isActive && templates.find(t => t.id === rule.selectedTemplate) && (
                          <>
                            <div style={{ marginBottom: 8 }}>
                              <strong>Status:</strong> {templates.find(t => t.id === rule.selectedTemplate).status}
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <strong>Categoria:</strong> {templates.find(t => t.id === rule.selectedTemplate).categoria}
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <strong>Idioma:</strong> {templates.find(t => t.id === rule.selectedTemplate).idioma}
                            </div>
                          </>
                        )}
                        {!rule.isActive && (extractTemplateVariables(templates.find(t => t.id === rule.selectedTemplate)).length > 0 || templates.find(t => t.id === rule.selectedTemplate)?.componentes.some(componente =>
                          componente.type === "BUTTONS" &&
                          componente.buttons &&
                          componente.buttons.some(button => button.type === "ORDER_DETAILS")
                        )) && (
                            <div style={{ marginBottom: 16 }}>
                              <strong>Variáveis do template:</strong>
                              {(() => {
                                const template = templates.find(t => t.id === rule.selectedTemplate);
                                const hasOrderDetailsButton = template.componentes.some(componente =>
                                  componente.type === "BUTTONS" &&
                                  componente.buttons &&
                                  componente.buttons.some(button => button.type === "ORDER_DETAILS")
                                );

                                const templateVariables = extractTemplateVariables(template);

                                // Se tem ORDER_DETAILS, adiciona todas as variáveis (1-7) mesmo se não estiverem no template
                                if (hasOrderDetailsButton) {
                                  for (let i = 1; i <= 7; i++) {
                                    if (!templateVariables.includes(i.toString())) {
                                      templateVariables.push(i.toString());
                                    }
                                  }
                                }

                                return templateVariables.map((variable, index) => {
                                  let variableLabel = '';
                                  if (variable === '1') variableLabel = 'Nome';
                                  else if (variable === '2') variableLabel = hasOrderDetailsButton ? 'Empresa' : 'Valor';
                                  else if (variable === '3') variableLabel = hasOrderDetailsButton ? 'Valor' : 'Empresa';
                                  else if (variable === '4') variableLabel = 'Data de Expiração PIX';
                                  else if (variable === '5') variableLabel = 'Código PIX Copia e Cola';
                                  else if (variable === '6') variableLabel = 'ID da Dívida';
                                  else if (variable === '7') variableLabel = 'CNPJ';
                                  else variableLabel = `Variável ${variable}`;

                                  return (
                                    <div key={index} style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8, padding: 8, background: '#f0f8ff', borderRadius: 4 }}>
                                      <span style={{ fontSize: 12, color: '#666', minWidth: 80 }}>
                                        Variável {variable}:
                                      </span>
                                      <span style={{ fontSize: 12, color: '#0066cc', fontWeight: 500 }}>
                                        {variableLabel}
                                      </span>
                                      <span style={{ fontSize: 10, color: '#999', fontStyle: 'italic' }}>
                                        (variável automática)
                                      </span>
                                    </div>
                                  );
                                });
                              })()}
                            </div>
                          )}
                        {!rule.isActive && templates.find(t => t.id === rule.selectedTemplate) && (
                          <>
                            <div>
                              <strong>Conteúdo original:</strong>
                              {templates.find(t => t.id === rule.selectedTemplate).componentes.map((componente, index) => (
                                <div key={index} style={{ marginTop: 4, paddingLeft: 8 }}>
                                  <strong>{componente.type}:</strong> {componente.text}
                                  {componente.buttons && (
                                    <div style={{ marginTop: 4, paddingLeft: 16 }}>
                                      {componente.buttons.map((button, btnIndex) => (
                                        <div key={btnIndex} style={{ fontSize: 12, color: '#666' }}>
                                          • {button.text}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>

                            {extractTemplateVariables(templates.find(t => t.id === rule.selectedTemplate)).length > 0 && (
                              <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #e0e0e0' }}>
                                <strong>Preview do template (com variável substituída):</strong>
                                {getTemplatePreview(templates.find(t => t.id === rule.selectedTemplate)).map((componente, index) => (
                                  <div key={index} style={{ marginTop: 4, paddingLeft: 8 }}>
                                    <strong>{componente.type}:</strong> {componente.text}
                                    {componente.buttons && (
                                      <div style={{ marginTop: 4, paddingLeft: 16 }}>
                                        {componente.buttons.map((button, btnIndex) => (
                                          <div key={btnIndex} style={{ fontSize: 12, color: '#666' }}>
                                            • {button.text}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    <div className={styles.formField}>
                      <Select
                        label="Template"
                        options={templateOptions}
                        value={rule.selectedTemplate}
                        onChange={e => handleRuleChange(idx, 'selectedTemplate', e.target.value)}
                        fullWidth
                        disabled={templatesLoading || rule.isActive}
                        placeholder={rule.isActive ? rule.originalTemplateName : (templatesLoading ? "Carregando templates..." : "Selecione um template")}
                      />
                    </div>
                    <div className={styles.formField}>
                      <StatusSelector
                        label="Status"
                        selectedStatus={rule.selectedStatuses}
                        handleStatusChange={rule.isActive ? () => { } : statuses => handleRuleChange(idx, 'selectedStatuses', statuses)}
                      />
                    </div>
                    <div className={styles.formField}>
                      <Select
                        label="Atraso médio"
                        options={delayOptions}
                        value={rule.selectedDelay}
                        onChange={rule.isActive ? () => { } : e => handleRuleChange(idx, 'selectedDelay', e.target.value)}
                        fullWidth
                        disabled={rule.isActive}
                      />
                    </div>
                    <div className={styles.formField}>
                      <DaySelector
                        label="Data do disparo"
                        selectedDays={rule.selectedDays}
                        handleDayChange={rule.isActive ? () => { } : days => handleRuleChange(idx, 'selectedDays', days)}
                      />
                    </div>
                    <div className={styles.formField}>
                      <Select
                        label="Frequência"
                        options={frequencyOptions}
                        value={rule.selectedFrequency}
                        onChange={rule.isActive ? () => { } : e => handleRuleChange(idx, 'selectedFrequency', e.target.value)}
                        fullWidth
                        disabled={rule.isActive}
                      />
                    </div>
                    <div className={styles.formField}>
                      <label className={styles.inputLabel}>
                        Hora do disparo
                      </label>
                      <div style={{ width: '100%' }}>
                        <CustomTimePicker
                          initialTime={rule.selectedTime}
                          onTimeChange={rule.isActive ? () => { } : time => handleRuleChange(idx, 'selectedTime', time)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                  <button onClick={handleAddRule} style={{
                    background: '#172A5A',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 20,
                    padding: '10px 28px',
                    fontSize: 16,
                    fontWeight: 500,
                    cursor: 'pointer'
                  }}>
                    + Adicionar mais regras ao disparo
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {showSuccessModal && (
        <Modal onClose={() => setShowSuccessModal(false)}>
          <div data-modal style={{ textAlign: 'center', padding: '20px' }}>
            <img src={successIcon} alt="Sucesso" style={{ width: 60, margin: '0 auto 16px' }} />
            <h3 style={{ margin: 0, fontWeight: 700, color: 'var(--dash-sidebar-primary)', marginBottom: '8px' }}>
            As regras foram salvas com sucesso!
            </h3>
          </div>
        </Modal>
      )}

      {showErrorModal && (
        <Modal onClose={() => setShowErrorModal(false)}>
          <div data-modal style={{ textAlign: 'center', padding: '20px' }}>
            <img src={errorIcon} alt="Erro" style={{ width: 60, margin: '0 auto 16px' }} />
            <h3 style={{ margin: 0, fontWeight: 700, color: '#d32f2f', marginBottom: '8px' }}>
              Erro ao salvar regras
            </h3>
            <p style={{ margin: '8px 0 0', color: '#888' }}>
              {errorMessage}
            </p>
          </div>
        </Modal>
      )}

      {showDeleteSuccessModal && (
        <Modal onClose={() => setShowDeleteSuccessModal(false)}>
          <div data-modal style={{ textAlign: 'center', padding: '20px' }}>
            <img src={successIcon} alt="Sucesso" style={{ width: 60, margin: '0 auto 16px' }} />
            <h3 style={{ margin: 0, fontWeight: 700, color: 'var(--dash-sidebar-primary)', marginBottom: '8px' }}>
            A regra foi excluída com sucesso!
            </h3>
          </div>
        </Modal>
      )}

      {showDeleteConfirmModal && (
        <Modal onClose={() => setShowDeleteConfirmModal(false)}>
          <div data-modal style={{ textAlign: 'center', padding: '28px 16px', maxWidth: 420 }}>
            <img src={AlertDeleteIcon} alt="Alerta de exclusão" style={{ width: 56, margin: '0 auto 12px' }} />
            <h3 style={{ fontWeight: 700, color: '#172A5A', marginBottom: 12, fontSize: 18 }}>
              Tem certeza que deseja excluir a regra?
            </h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 24 }}>
              <button
                onClick={confirmDeleteRule}
                style={{
                  background: '#3CB300',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  padding: '10px 18px',
                  fontSize: 16,
                  fontWeight: 500,
                  cursor: 'pointer',
                  minWidth: 140
                }}
              >
                Sim, excluir agora
              </button>
              <button
                onClick={() => setShowDeleteConfirmModal(false)}
                style={{
                  background: '#C30000',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  padding: '10px 18px',
                  fontSize: 16,
                  fontWeight: 500,
                  cursor: 'pointer',
                  minWidth: 140
                }}
              >
                Não, cancelar exclusão
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CommunicationDispatcher; 